import FileField from '@com/fields/FileField'
import FormMixin from '@com/mixins/form.mixin'

import { fileService } from '@api/file.service'
import { usersService } from '@api/users.service'
import { i18n } from '@js/i18n'
import { DOCUMENT_POLICIES } from '@const'

export default {
  mixins: [FormMixin],
  components: { FileField },
  props: ['schema', 'kyc', 'activeStep', 'finalStep'],
  data: _ => ({
    i18n,
    form: {},
    documents: {},
    values: {
      countries: [],
      industries: [],
      documentTypes: []
    }
  }),

  async created () {
    const values = await usersService.loadEnums()
    this.values.countries = [ '', ...(values).data('countries') ]
    this.values.industries = [ '', ...(values).data('industry') ]
    this.values.documentTypes = [ '', ...(values).data('id_document') ]
  },

  methods: {
    async uploadDocuments () {
      await Promise.all(Object.values(this.documents).map(document =>
        document && DOCUMENT_POLICIES[document.type]
          ? uploadSingleDocument.apply(this, [document]) : function () {}
      ))
      async function uploadSingleDocument (document) {
        if (document.isUploaded) return
        this.documents[document.type] = await fileService.uploadSingleDocument(document)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/vue/app/verification/spec/step.mixin.js